import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { BlueprintDeployment } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import Timestamp from "components/Timestamp";

const TemplateDeploymentsCreatedAtCell = ({
  item: deployment,
  ...cellProps
}: TableSimpleCellProps<BlueprintDeployment>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <Timestamp timestamp={deployment.createdAt} />
    </TableSimpleCell>
  );
};

export default TemplateDeploymentsCreatedAtCell;
